import TermsPage from './TermsPage.container';

export default TermsPage;
